import { action } from 'typesafe-actions';

import { SET_QUANTITY } from './constants';

export const setQuantity = (quantity: number) => action(SET_QUANTITY, quantity);
